<template>
  <div class="flex flex-col">
    <div class="flex items-center mb-6">
      <icon name="calendar_2" class="w-10 h-10 mr-3 text-tertiary" :center="false" />
      <div class="flex flex-col">
        <span class="mb-1 text-sm font-semibold">{{ moment(viewing.appointment_at).format('dddd Do MMMM YYYY') }}</span>
        <span class="text-sm font-semibold">{{ viewing.appointment_time_range }}</span>
      </div>
    </div>
    <div class="flex items-center mb-6">
      <icon name="prime_property" class="w-10 h-10 mr-3 text-tertiary" :center="false" />
      <div class="flex flex-col">
        <span class="w-48 text-sm font-semibold mb-1">{{ viewing.prime_property.address }}</span>
        <span class="text-xs">+{{ viewing.property_count }} other properties</span>
      </div>
    </div>
    <div class="flex items-center mb-6">
      <icon name="host_2" class="w-10 h-10 mr-3 text-tertiary" :center="false" />
      <div class="flex flex-col">
        <span class="mb-1 text-sm font-semibold">{{ viewing.host.name }}</span>
        <span class="text-xs mb-1">{{ viewing.host.phone }}</span>
        <span class="text-xs">{{ viewing.host.email }}</span>
      </div>
    </div>

    <div v-if="viewing.meeting_url" class="flex items-center">
      <icon name="link" class="w-10 h-10 mr-3 text-tertiary" :center="false" />
      <div class="flex flex-col">
        <a :href="viewing.meeting_url" class="text-tertiary text-xs">{{ viewing.meeting_url }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ViewingDetails',
  props: ['viewing'],

  methods: {
    moment
  }
}
</script>
